import { render, staticRenderFns } from "./PathologistHeaderText.vue?vue&type=template&id=e56e00a6&scoped=true&"
import script from "./PathologistHeaderText.vue?vue&type=script&lang=js&"
export * from "./PathologistHeaderText.vue?vue&type=script&lang=js&"
import style0 from "./PathologistHeaderText.vue?vue&type=style&index=0&id=e56e00a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e56e00a6",
  null
  
)

export default component.exports